import { FaBoxOpen, FaShippingFast, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const stageIcons = {
  Processing: <FaBoxOpen size={20} />,
  Shipped: <FaShippingFast size={20} />,
  Delivered: <FaCheckCircle size={20} />,
  Cancelled: <FaTimesCircle size={20} />,
};

const OrderTracking = ({ selectedOrder }) => {
  const stages = ["Processing", "Shipped", "Delivered", "Cancelled"];

  const currentStatus =
    selectedOrder.status.charAt(0).toUpperCase() +
    selectedOrder.status.slice(1).toLowerCase();

  const getColor = (stage) => {
    if (currentStatus === "Cancelled") {
      return stage === "Cancelled" ? "red" : "#ccc";
    }
    return stages.indexOf(stage) <= stages.indexOf(currentStatus)
      ? "green"
      : "#ccc";
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h3>Order Tracking</h3>
      <div style={{ display: "flex", justifyContent: "space-between", position: "relative" }}>
        {stages.map((stage, index) => {
          const isActive = stage === currentStatus;
          const isCompleted = stages.indexOf(stage) <= stages.indexOf(currentStatus);
          const color = stage === "Cancelled" && currentStatus === "Cancelled"
            ? "red"
            : isCompleted
            ? "green"
            : "#aaa";

          return (
            <div
              key={index}
              style={{
                flex: 1,
                textAlign: "center",
                color,
                fontWeight: isActive ? "bold" : "normal",
                position: "relative",
                transition: "all 0.4s ease",
              }}
            >
              <div
                style={{
                  height: "30px",
                  width: "30px",
                  backgroundColor: getColor(stage),
                  borderRadius: "50%",
                  margin: "0 auto 5px auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background-color 0.4s ease",
                  color: "white",
                }}
              >
                {stageIcons[stage]}
              </div>
              <div>{stage}</div>

              {index < stages.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    left: "50%",
                    transform: "translateX(15px)",
                    width: "100%",
                    height: "2px",
                    backgroundColor: getColor(stage),
                    zIndex: -1,
                    transition: "background-color 0.4s ease",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderTracking;
